import { render } from "./QuextUserForm.vue?vue&type=template&id=1ca96aef&scoped=true"
import script from "./QuextUserForm.vue?vue&type=script&lang=js"
export * from "./QuextUserForm.vue?vue&type=script&lang=js"

import "./QuextUserForm.vue?vue&type=style&index=0&id=1ca96aef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca96aef"]])

export default __exports__